import { Link } from "react-router-dom";
import { Users, Music, Disc3, TrendingUp, Guitar, CalendarDays, GraduationCap, Award, ChevronRight } from "lucide-react";

const TILES = [
  { title: "Artists & Creators", icon: Users, color: "from-pink-500 to-rose-500", path: "/artists" },
  { title: "Genres & Traditions", icon: Music, color: "from-purple-500 to-violet-600", path: "/genres" },
  { title: "Songs & Albums", icon: Disc3, color: "from-teal-400 to-cyan-500", path: "/charts" },
  { title: "Charts & Trending", icon: TrendingUp, color: "from-orange-400 to-rose-500", path: "/charts" },
  { title: "Instruments", icon: Guitar, color: "from-amber-400 to-orange-500", path: "/instruments" },
  { title: "Festivals & Events", icon: CalendarDays, color: "from-rose-500 to-red-500", path: "/events" },
  { title: "Music Education", icon: GraduationCap, color: "from-blue-500 to-indigo-600", path: "/instruments" },
  { title: "Hall of Fame", icon: Award, color: "from-fuchsia-500 to-purple-600", path: "/hall-of-fame" },
];

export const QuickLinks = () => (
  <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
    <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-3">
      {TILES.map((t) => (
        <Link
          key={t.title}
          to={t.path}
          data-testid={`quicklink-${t.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          className="card-lift bg-white rounded-2xl border border-slate-100 px-3 py-3.5 flex items-center gap-2.5 group"
        >
          <span className={`w-10 h-10 rounded-full flex items-center justify-center text-white bg-gradient-to-br shrink-0 ${t.color}`}>
            <t.icon className="w-4.5 h-4.5" style={{ width: 18, height: 18 }} />
          </span>
          <span className="text-[11px] font-bold text-slate-800 leading-tight flex-1">{t.title}</span>
          <ChevronRight className="w-3.5 h-3.5 text-slate-300 group-hover:text-pink-500 transition-colors shrink-0" />
        </Link>
      ))}
    </div>
  </section>
);

export default QuickLinks;
